<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col md="12">
                <b-card>
                    <div slot="header">
                        <b-row>
                            <b-col md="6" class="text-start">
                                <strong>Constraint Master</strong>
                            </b-col>
                            <b-col md="6" class="text-right">
                                <b-button variant="primary" size="sm" @click="addconstraint()"><i class="fa fa-plus" aria-hidden="true"></i>
                                    ADD New Constraint </b-button>&nbsp;
                                <b-button variant="primary" size="sm" @click="search()"><i class="fa fa-search" aria-hidden="true"></i> Search</b-button>
                            </b-col>
                        </b-row>
                    </div>

                    <div v-if="add_constraint">
                        <h4>Add Constraint Master</h4>
                        <hr> <br>
                        <b-form @submit.prevent="validateForm('form-1')"  data-vv-scope="form-1">
                            <b-row>
                                <b-col md="4" class="mb-3">
                                    <b-form-group>
                                        <b>Client Name <span style="color: red;">*</span></b>
                                        <v-select :options="clientname" v-model="customer.selectclientname" name="client name" placeholder="Select Client Name" class="mt-2"  v-validate="'required'"
                                        :class="{ input: true, 'is-invalid': errors.has('form-1.client name'),
                                        }" ></v-select>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                            <i
                                                class="fa fa-warning"
                                                v-show="errors.has('client name')"
                                            ></i>
                                            </span>
                                            <span
                                            style="width:240px"
                                            v-show="errors.has('form-1.client name')"
                                            class="help text-danger"
                                            >{{ errors.first("form-1.client name") }}</span
                                            >
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
            
                                <b-col md="4" class="mb-3">
                                    <b-form-group>
                                        <b>Constraint <span style="color: red;">*</span></b>
                                        <b-form-input v-model.trim="customer.constraint_value" placeholder="Enter Constraint"  name="constraint" class="mt-2" v-validate="'required'"
                                        :class="{ input: true, 'is-invalid': errors.has('form-1.constraint'),
                                        }" ></b-form-input>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                            <i
                                                class="fa fa-warning"
                                                v-show="errors.has('constraint')"
                                            ></i>
                                            </span>
                                            <span
                                            style="width:240px"
                                            v-show="errors.has('form-1.constraint')"
                                            class="help text-danger"
                                            >{{ errors.first("form-1.constraint") }}</span
                                            >
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
            
                                <b-col md="4" class="mb-3">
                                    <b-form-group>
                                        <b>IS Active <span style="color: red;">*</span></b>
                                        <b-form-select v-model="customer.selectedstatus" :options="optionsactive" class="mt-2" name="status" v-validate="'required'"
                                        :class="{ input: true, 'is-invalid': errors.has('form-1.status'),
                                        }"></b-form-select>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                            <i
                                                class="fa fa-warning"
                                                v-show="errors.has('status')"
                                            ></i>
                                            </span>
                                            <span
                                            style="width:240px"
                                            v-show="errors.has('form-1.status')"
                                            class="help text-danger"
                                            >{{ errors.first("form-1.status") }}</span
                                            >
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
            
                                <b-col md="4" class="mb-3">
                                    <b-form-group>
                                        <b>IS Logistics Constraint <span style="color: red;">*</span></b>
                                        <b-form-select v-model="customer.selectedlogistics_const" :options="islogoptions" class="mt-2" name="Logisticsstatus" v-validate="'required'"
                                        :class="{ input: true, 'is-invalid': errors.has('form-1.Logisticsstatus'),
                                        }"></b-form-select>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                            <i
                                                class="fa fa-warning"
                                                v-show="errors.has('Logisticsstatus')"
                                            ></i>
                                            </span>
                                            <span
                                            style="width:240px"
                                            v-show="errors.has('form-1.Logisticsstatus')"
                                            class="help text-danger"
                                            >{{ errors.first("form-1.Logisticsstatus") }}</span
                                            >
                                        </b-input-group>
                                    </b-form-group>
                                    
                                </b-col>
            
                                <b-col md="4" class="mt-4">
                                    <b-button variant="primary" size="md"  type="submit"> <i class="fa fa-check-circle-o" aria-hidden="true"></i> Save</b-button> &nbsp;
                                    <b-button variant="danger" @click="clear()"><i class="fa fa-ban" aria-hidden="true"></i> Clear</b-button>
                                </b-col>
                            </b-row>
                        </b-form>
                    </div>

                    <div v-if="search_constraint">
                        <h4>Search Constraint Master</h4>
                        <hr> <br>
                        <b-row>
                            <b-col md="5">
                                <b>Constraint</b>&nbsp;
                                <b-input type="text" class="mt-2" v-model.trim="searchconstraint" placeholder="Enter Constraint"/>
                            </b-col>
                            <b-col md="4">
                                <b>IS Active</b>
                                <b-form-select v-model="searchstatus" :options="optionsactive" class="mt-2"></b-form-select>
                            </b-col>
                            <b-col md="3" class="mt-4">
                                <b-button variant="primary" size="md" @click="ConstraintList()"> <i class="fa fa-search" aria-hidden="true"></i> Search</b-button> &nbsp;
                                <b-button variant="danger" @click="clear()"><i class="fa fa-ban" aria-hidden="true"></i> Clear</b-button>
                            </b-col>
                        </b-row>
                        <br>
                    </div>

                    <div>
                        <b-row>
                            <b-col md="12" class="text-right">
                                <b text-variant="red">Total Records :<span style="color: red;"> {{totalRows}}</span></b>
                            </b-col>
                            <b-col md="12">
                                <!-- :current-page="currentPage"  :per-page="perPage"  -->
                                <b-table show-empty responsive :items="items_rb" :fields="fields"  :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    @filtered="onFiltered"    :outlined="outlined" :busy="isBusy">
                                    <template slot="sno" slot-scope="row">
                                        <div>
                                            {{ row.index+1 }}
                                        </div>
                                    </template>
                                    <template slot="isactive" slot-scope="row">
                                        <div v-if="row.item.mandatory_constraint==1">
                                            <span class="badge badge-success" v-if="row.item.isactive=='1'">
                                                Active
                                            </span>
                                            <span class="badge badge-success" v-if="row.item.isactive=='Yes'">
                                                Active
                                            </span>
                                            <span class="badge badge-danger"  v-if="row.item.isactive=='0'">In Active</span>
                                            <span class="badge badge-danger"  v-if="row.item.isactive=='No'">In Active</span>
                                        </div>
                                        <div v-else>
                                            <span class="badge badge-success" v-if="row.item.isactive=='1'" style="cursor: pointer;" @click="activeInactive(row.item)">
                                                Active
                                            </span>
                                            <span class="badge badge-success" v-if="row.item.isactive=='Yes'" style="cursor: pointer;"  @click="activeInactive(row.item)">
                                                Active
                                            </span>
                                            <span class="badge badge-danger"  v-if="row.item.isactive=='0'" style="cursor: pointer;"  @click="activeInactive(row.item)">In Active</span>
                                            <span class="badge badge-danger"  v-if="row.item.isactive=='No'" style="cursor: pointer;"  @click="activeInactive(row.item)">In Active</span>
                                        </div>
                                    </template>
                                    <template slot="action" slot-scope="row">
                                        <div v-if="row.item.mandatory_constraint==0">
                                            <b-button size="sm" @click="editConstraintmodelopen(row.item)"><i class="fa fa-pencil" ></i></b-button>
                                        </div>
                                    </template>
                                </b-table>
                            </b-col>
                        </b-row>
                    </div>

                    <!-- <b-row>
                        <b-col sm="12" class="text-right">
                          <br>
                               <p style="margin-top: 5px;"> <b>Total Records :<span style="color:red;"> {{totalRows}}</span></b> </p>
                        </b-col>
                        <b-col md="12" class="my-1" >
                            <paginate 
                                :page-count="noofpages"
                                :page-range="10"
                                :margin-pages="2"
                                :click-handler="clickCallback"
                                :prev-text="'Prev'"
                                :next-text="'Next'"
                                :container-class="'pagination'"
                                :page-class="'page-item'">
                            </paginate>
                        </b-col>   
                    </b-row>  -->

                    <b-modal title="Edit Constraint Master" v-model="showconstraintmodal" size="lg" @ok="showconstraintmodal = false" hide-footer>
                        <div>
                            <div id="overlaymodel" >
                                <div class="modelloader"></div>
                            </div>
                            <b-form
                            @submit.prevent="validateForm1('form-2')"
                            data-vv-scope="form-2">
                            <b-row>
                                <b-col md="6" class="mb-3">
                                    <b-form-group>
                                        <b>Client Name <span style="color: red;">*</span></b>
                                        <v-select :options="clientname" v-model="user.selectclientname" name="client name" placeholder="Select Client Name" class="mt-2"  v-validate="'required'"
                                        :class="{ input: true, 'is-invalid': errors.has('form-2.client name'),
                                        }" ></v-select>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                            <i
                                                class="fa fa-warning"
                                                v-show="errors.has('client name')"
                                            ></i>
                                            </span>
                                            <span
                                            style="width:240px"
                                            v-show="errors.has('form-2.client name')"
                                            class="help text-danger"
                                            >{{ errors.first("form-2.client name") }}</span
                                            >
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
            
                                <b-col md="6" class="mb-3">
                                    <b-form-group>
                                        <b>Constraint <span style="color: red;">*</span></b>
                                        <b-form-input v-model.trim="user.constraint_value" placeholder="Enter Constraint"  name="constraint" class="mt-2" v-validate="'required'"
                                        :class="{ input: true, 'is-invalid': errors.has('form-2.constraint'),
                                        }" ></b-form-input>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                            <i
                                                class="fa fa-warning"
                                                v-show="errors.has('constraint')"
                                            ></i>
                                            </span>
                                            <span
                                            style="width:240px"
                                            v-show="errors.has('form-2.constraint')"
                                            class="help text-danger"
                                            >{{ errors.first("form-2.constraint") }}</span
                                            >
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
            
                                <b-col md="6" class="mb-3">
                                    <b-form-group>
                                        <b>IS Active <span style="color: red;">*</span></b>
                                        <b-form-select v-model="user.selectedstatus" :options="optionsactive" class="mt-2" name="status" v-validate="'required'"
                                        :class="{ input: true, 'is-invalid': errors.has('form-2.status'),
                                        }"></b-form-select>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                            <i
                                                class="fa fa-warning"
                                                v-show="errors.has('status')"
                                            ></i>
                                            </span>
                                            <span
                                            style="width:240px"
                                            v-show="errors.has('form-2.status')"
                                            class="help text-danger"
                                            >{{ errors.first("form-2.status") }}</span
                                            >
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
            
                                <b-col md="6" class="mb-3">
                                    <b-form-group>
                                        <b>IS Logistics Constraint <span style="color: red;">*</span></b>
                                        <b-form-select v-model="user.selectedlogistics_const" :options="islogoptions" class="mt-2" name="Logisticsstatus" v-validate="'required'"
                                        :class="{ input: true, 'is-invalid': errors.has('form-2.Logisticsstatus'),
                                        }"></b-form-select>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                            <i
                                                class="fa fa-warning"
                                                v-show="errors.has('Logisticsstatus')"
                                            ></i>
                                            </span>
                                            <span
                                            style="width:240px"
                                            v-show="errors.has('form-2.Logisticsstatus')"
                                            class="help text-danger"
                                            >{{ errors.first("form-2.Logisticsstatus") }}</span
                                            >
                                        </b-input-group>
                                    </b-form-group>
                                    
                                </b-col>
            
                                <b-col md="12" class="mb-2 text-right">
                                    <b-button variant="primary" size="md"  type="submit"> <i class="fa fa-check-circle-o" aria-hidden="true"></i> Update</b-button> &nbsp;
                                    <b-button variant="danger" @click="clear()"><i class="fa fa-ban" aria-hidden="true"></i> Clear</b-button>
                                </b-col>
                            </b-row>
                            </b-form>
                        </div>
                    </b-modal>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import auth from "@/utils/auth";
export default {
    data() {
        return {
            isBusy : false,
            totalRows :0,
            items_rb: [],
            fields:[
                {key:'sno', label:'S.No.'},
                {key:'constraint_id', label:'Constraint ID'},
                {key:'rb_constraint', label:'Constraint'},
                {key:'clientname', label:'Client Name'},
                {key:'isactive', label:'Is Active'},
                {key:'is_logisticconstraint', label:'IS Logistics Issue'},
                {key:'createdby',label:'Created By'},
                {key:'createddate', label:'Created On'},
                {key:'lastmodifiedby',label:'Updated By'},
                {key:'lastmodifieddate', label:'Updated On'},
                {key:'action',label:'Action'}
            ],

            //pagination 
             // currentPage: 1,
            // perPage:  20,
            sortBy: null,
            sortDesc: false,
            sortDirection: 'asc',
            // noofpages:'',
            // pageNum:1,
            // listingpageno:1,

            //end pagination

            //add start
            add_constraint:false,
            customer : {
                selectclientname :'',
                constraint_value:'',
                selectedstatus: null,
                selectedlogistics_const: null
            },
            clientnamelist: [],
            clientname :[],
            optionsactive: [
                { value: null, text: 'Please select status' },
                { value: 'Yes', text: 'Yes' },
                { value: 'No', text: 'No' },
            ],
            islogoptions: [
                { value: null, text: 'Please select status' },
                { value: 'Yes', text: 'Yes' },
                { value: 'No', text: 'No' },
            ],
            //add end

            //search start
            search_constraint:false,
            searchconstraint :'',
            searchstatus :null,

            //edit start
            showconstraintmodal : false,
            user :{
                selectclientname :'',
                constraint_value:'',
                selectedstatus: null,
                selectedlogistics_const: null
            },
            constraint_id :'',
            //edit end

        }
    },

    created() {
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        this.allclientlist()
        this.ConstraintList();
    },
    

    methods: {
        activeInactive(data){
            console.log("data",data)
            this.$fire({
                text: data.isactive=='Yes'?"Do you want to change the status In Active?":"Do you want to change the status Active?",
                type: "warning",
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: "OK",
                cancelButtonText: "Cancel",
                showLoaderOnConfirm: true 
            }).then((result) => {
                console.log("result", result)
                /* Read more about isConfirmed, isDenied below */
                if (result.value) {
                    document.getElementById("overlay").style.display = "block";
                    var userdata = localStorage.getItem("userData");
                    var userInfo = JSON.parse(userdata);

                    const obj = {
                        id : `${data.constraint_id}`,
                        isActive : data.isactive=='Yes'?'No':'Yes',
                        lastmodifiedby :`${userInfo.userfirstname + ' ' + userInfo.userlastname}`,
                    } 
                    this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/updateIsActiveConstraintMaster`,obj)
                    .then((result) => {
                        console.log("result",result)
                        document.getElementById("overlay").style.display = "none";
                        if (result.body.returnmsg=="Successful") {
                            this.$fire({
                                text: result.body.returnmsg,
                                type: "success",
                                timer: 30000,
                            });
                            this.ConstraintList()
                        }
                        else{
                            this.$fire({
                                text: result.body.returnmsg,
                                type: "error",
                                timer: 30000,
                            });
                        }
                    })
                    .catch((ex) => {
                        console.log("error", ex);
                    });
                } else if (result.dismiss) {
                    this.$fire({
                        text: 'Status Is Not Changes',
                        type: "error",
                        timer: 30000,
                    });
                }
            });
        },

        addconstraint(){
            this.search_constraint=false
            this.add_constraint=!this.add_constraint
            // this.allclientlist()  
            this.clear()
              
        },

        search(){
            this.add_constraint=false
            this.search_constraint=!this.search_constraint
            this.clear()
        },

        clear(){
            this.customer={
                selectclientname :'',
                constraint_value:'',
                selectedstatus: null,
                selectedlogistics_const: null
            };
            this.user={
                selectclientname :'',
                constraint_value:'',
                selectedstatus: null,
                selectedlogistics_const: null
            };
            this.searchstatus= null;
            this.searchconstraint='';
            this.clientnamelist =[];
            this.clientname =[];
            this.ConstraintList()
            this.allclientlist()   
        },

        validateForm(scope) {
            this.$validator.validateAll(scope).then((result) => {
                console.log("-----------",result)
                if (result) {
                    this.addRB_ConstraintMasterinfo();
                }
            });
        },

        addRB_ConstraintMasterinfo : function () {
            document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            
            const Obj = {
                client_id :  `${this.customer.selectclientname==null?"":this.customer.selectclientname.key}`,
                rb_constraint : this.customer.constraint_value,
                isactive : this.customer.selectedstatus,
                is_logisticconstraint : this.customer.selectedlogistics_const,
                createdby : `${userInfo.userfirstname + ' ' + userInfo.userlastname}`,
                sysusermasterid :userInfo.sysusermasterid
            }
            // return false;
            this.$http
            .post(`${CONSTANTS.MIGRATION_API_URL}/addrbconstraintmasterinfo`,Obj)
            .then((result) => {
                console.log(result);
                document.getElementById("overlay").style.display = "none";
                if (result.body.returnmsg === "Successful") {
                this.$fire({
                    text: result.body.returnvalue,
                    type: "success",
                    timer: 30000,
                });
                this.add_constraint = false;
                this.clear();
                this.customer = {};
                this.ConstraintList();
                this.clientnamelist =[];
                this.clientname =[];
                } else {
                    this.$fire({
                        text: result.body.returnvalue,
                        type: "error",
                        timer: 30000,
                    });
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        allclientlist(){
            console.log("innnnn");
            this.clientnamelist =[];
            this.clientname =[];
            this.customer = {};
            const Obj = {}
            // return false;
            this.$http
            .post(`${CONSTANTS.MIGRATION_API_URL}/getallclientlist`,Obj)
            .then((result) => {
                console.log("result",result)
                if (result.body.returnmsg === "Successful") {
                    this.clientnamelist = result.body.returnvalue;

                    this.clientnamelist.forEach(value => {
                        var client = {
                            key:value.clientmasterid,
                            label:value.clientname
                        }
                        this.clientname.push(client)
                        if (value.clientmasterid==27 && value.clientname=="Firstcry") {
                            this.customer.selectclientname = client;
                            this.user.selectclientname = client;
                        }
                    });
            
                } else {
                    this.clientnamelist =[];
                    this.clientname =[];
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        // clickCallback (pageNum){
        //     this.listingpageno = pageNum;
        //     this.ConstraintList(pageNum);
        // },

        ConstraintList(){
            this.items_rb =[];
            this.totalRows=0;
            this.isBusy=true;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            
            const Obj = {
                sysusermasterid : userInfo.sysusermasterid,
                // page_no :pageNum,
                type :'List',
                constraint : this.searchconstraint==""?'':this.searchconstraint,
                isactive : this.searchstatus==null?'':this.searchstatus
            }
            // return false;
            this.$http
            .post(`${CONSTANTS.MIGRATION_API_URL}/getconstraintmasterList`,Obj)
            .then((result) => {
                this.isBusy=false;
                if (result.body.returnmsg === "Successful") {
                    this.items_rb = result.body.returnvalue;
                    this.totalRows = result.body.returnvalue.length;
                    // this.noofpages=parseInt(this.totalRows)/20;
                    // this.noofpages=Math.ceil( this.noofpages);
                } else {
                    this.items_rb =[];
                    this.totalRows=0;
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        handleClientNameChange(selectedValue) {
        const selectedKeyObject = this.findKeyObjectByLabel(selectedValue);
            // Do something with the selected key object
            console.log('Selected key object:', selectedKeyObject);
            this.user.selectclientname = selectedKeyObject;
        },

        findKeyObjectByLabel(label) {
            return this.clientname.find(item => item.label === label) || null;
        },

        editConstraintmodelopen(data){
            this.user = {}
            console.log(data)
            this.clientnamelist =[];
            this.clientname =[];
            this.allclientlist()
            this.add_constraint=false;
            this.search_constraint=false;
            this.constraint_id="";
            this.constraint_id = data.constraint_id;
            this.user.selectclientname = data.client_id;
            if ( this.user.selectclientname) {
                this.handleClientNameChange(this.user.selectclientname)
            }
            this.user.constraint_value = data.rb_constraint;
            this.user.selectedstatus = data.isactive;
            this.user.selectedlogistics_const = data.is_logisticconstraint
            this.showconstraintmodal=!this.showconstraintmodal

        },

        handleClientNameChange(selectedValue) {
        const selectedKeyObject = this.findKeyObjectByLabel(selectedValue);
            // Do something with the selected key object
            console.log('Selected key object:', selectedKeyObject);
            this.user.selectclientname = selectedKeyObject;
        },

        findKeyObjectByLabel(label) {
            return this.clientname.find(items_rb => items_rb.label === label) || null;
        },

        validateForm1(scope) {
            this.$validator.validateAll(scope).then((result) => {
                console.log("-----------",result)
                if (result) {
                    this.update_ConstraintMasterinfo();
                }
            });
        },
        
        update_ConstraintMasterinfo(){
            document.getElementById("overlaymodel").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            
            const Obj = { 
                constraint_id : this.constraint_id,
                client_id :  this.user.selectclientname==null?"":this.user.selectclientname.key,
                rb_constraint : this.user.constraint_value,
                isactive : this.user.selectedstatus,
                is_logisticconstraint : this.user.selectedlogistics_const,
                lastmodifiedby : `${userInfo.userfirstname + ' ' + userInfo.userlastname}`,
                sysusermasterid :userInfo.sysusermasterid
            }
            // return false;
            this.$http
            .post(`${CONSTANTS.MIGRATION_API_URL}/editrbconstraintmaster`,Obj)
            .then((result) => {
                console.log(result);
                document.getElementById("overlaymodel").style.display = "none";
                if (result.body.returnmsg === "Successful") {
                this.$fire({
                    text: result.body.returnvalue,
                    type: "success",
                    timer: 30000,
                });
                this.showconstraintmodal = false;
                this.clear();
                this.user = {};
                this.ConstraintList();
                this.clientnamelist =[];
                this.clientname =[];
                } else {
                    this.$fire({
                        text: result.body.returnvalue,
                        type: "error",
                        timer: 30000,
                    });
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        }
    },
}
</script>